
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { DialogJsonBoxComponent } from './dialog-json-box.component';



@NgModule({
  declarations: [
    DialogJsonBoxComponent,
  ],

  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
  ],

  exports: [
    DialogJsonBoxComponent,
  ],

  providers: [ ],

})

export class DialogJsonBoxModule { }
